import { z } from "zod";

export const DTOPageRedirectCreateBody = z.object({
  pagePersistentId: z.string(),
  path: z.string(),
});

export const DTOPageRedirectUpdateBody = DTOPageRedirectCreateBody.partial();

export const DTOPageRedirect = z.object({
  id: z.string(),
  pagePersistentId: z.string(),
  path: z.string(),
});

export const DTOPageRedirectListResponse = z.object({
  redirects: DTOPageRedirect.array(),
});

export const DTOPageRedirectResponse = z.object({
  redirect: DTOPageRedirect,
});

export const DTOPageRedirectDeleteResponse = z.object({
  success: z.boolean(),
});

export type DTOPageRedirectCreateBody = z.infer<typeof DTOPageRedirectCreateBody>;
export type DTOPageRedirectUpdateBody = z.infer<typeof DTOPageRedirectUpdateBody>;
export type DTOPageRedirect = z.infer<typeof DTOPageRedirect>;
export type DTOPageRedirectListResponse = z.infer<typeof DTOPageRedirectListResponse>;
export type DTOPageRedirectResponse = z.infer<typeof DTOPageRedirectResponse>;
export type DTOPageRedirectDeleteResponse = z.infer<typeof DTOPageRedirectDeleteResponse>;
